import { useEffect, useRef, useState } from "react";
import type { CmmdBoardTask } from "@cmmd-forge/contracts";

import type { ProjectTaskMobileSection } from "./ProjectTaskMobileTabs";

export function useProjectTaskEditorState(task: CmmdBoardTask) {
  const [title, setTitle] = useState(task.title);
  const [description, setDescription] = useState(task.description ?? "");
  const [savedDescription, setSavedDescription] = useState(task.description ?? "");
  const [mobileSection, setMobileSection] = useState<ProjectTaskMobileSection>("description");
  const taskIdRef = useRef(task.id);
  const authoritativeTitleRef = useRef(task.title);
  const authoritativeDescriptionRef = useRef(task.description ?? "");

  useEffect(() => {
    const nextDescription = task.description ?? "";
    if (taskIdRef.current !== task.id) {
      taskIdRef.current = task.id;
      setTitle(task.title);
      setDescription(nextDescription);
      setSavedDescription(nextDescription);
      setMobileSection("description");
    } else {
      setTitle((current) => (current === authoritativeTitleRef.current ? task.title : current));
      setDescription((current) =>
        current === authoritativeDescriptionRef.current ? nextDescription : current,
      );
      setSavedDescription(nextDescription);
    }
    authoritativeTitleRef.current = task.title;
    authoritativeDescriptionRef.current = nextDescription;
  }, [task.id, task.title, task.description]);

  return {
    title,
    setTitle,
    description,
    setDescription,
    savedDescription,
    setSavedDescription,
    mobileSection,
    setMobileSection,
  } as const;
}
